import React from "react"
import { APIPost, wrapPromise } from "API.js"
import { Loading } from "c/Loading/Loading.js"
import { Col, Container, Row } from "reactstrap"
import { useParams } from "react-router-dom"
  
const Product = React.lazy(() => import("./Product.js"));
 
const fetchProduct = (productId) => { 
	const body = {"action": "get_products", "product_ids": [productId]}
	let url = "products";   
	return wrapPromise(APIPost(url, body).then(res => {return res.data}), "products");
}; 
  
export const ProductPage = () => {   
	const urlParams = useParams();
	const productId = urlParams.productId
	const getProduct = (fetchProduct(productId))
 
	return ( 
		<React.Suspense fallback={<Loading showLoading={true} inFront />} >
			<Container >
				<Row>
					<Col className="p-4 p-lg-2 px-lg-4">
						<Product getProduct={getProduct} />
					</Col>
				</Row>
			</Container>
		</React.Suspense>
	)
}

